<template>
  <div class="">
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box">
            <div style="display: flex" class="font_size_12"></div>
            <div class="Addcompanies">
              <div
                class="font1290C9 cuspoint textdecoration font20"
                @click="addDialog = true"
              >
                {{ $t("DataManagement.Addcompanies") }}
              </div>
              <el-button
                class="btn_export"
                :disabled="$store.state.app.changeList.length == 0"
                @click="RescanCheckBook"
                >{{ $t("DataManagement.RiskScan") }}</el-button
              >
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-table
              class="spec_table table_height_30 table_font_size_14"
              :data="yourUsagelist"
              style="width: 100%"
              empty-text="No Data"
              @selection-change="handleSelectionChange"
              row-key="id"
              :key="refresh"
            >
              <el-table-column
                v-if="isOpenSlct"
                type="selection"
                width="40 "
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                :label="$t('DataManagement.Date')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.updateTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                width="550"
                class-name="company company_link company_link_tooltip_normal"
                :label="$t('DataManagement.CompanyName')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    class="table-content company_link"
                    @click="setid(scope.row)"
                  >
                    {{ scope.row.companyName }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                prop="Country"
                :label="$t('DataManagement.Country')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.countryName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyTypeEn"
                :label="$t('DataManagement.CompanyType')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyTypeEn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyStatusEn"
                :label="$t('DataManagement.CompanyStatus')"
                align="left"
                width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyStatusEn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyDqi"
                :label="$t('DataManagement.DQI')"
                align="left"
                width="50"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyDqi
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop=""
                :label="$t('DataManagement.Download')"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span
                    class="table-content flex_center"
                    @click="Down(scope.row)"
                  >
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Download')"
                      placement="top"
                      ><svg
                        t="1723022129119"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="6324"
                        width="28"
                        height="28"
                      >
                        <path
                          d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                          fill="#1296db"
                          p-id="6325"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <template slot="empty">
                <div>
                  <img
                    style="width: 50%; height: 50%"
                    src="../../../../assets/images/noDate.png"
                    alt=""
                  />
                </div>
              </template>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                <span
                  class="foundOverNum"
                  :style="{ color: $store.state.app.themeColor }"
                  >&nbsp;{{ page.total | FilterNum }}&nbsp;</span
                >
                results for "{{ $t("DataManagement.AllCompanies") }}"
              </div>
            </div>
            <!-- <div v-if="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
        <!-- <div class="CompanyCompany" v-show="Compare">
          <compareCompanys :compareList="compareList" @CompareShowfalse="CompareShow($event)"></compareCompanys>
        </div> -->
      </div>
    </div>
    <addCompany :addDialog="addDialog" @closeAdd="closeAdd"></addCompany>
    <!-- <div class="CompanyCompany" v-show="Compare">
          <compareCompanys :compareList="compareList" @CompareShowfalse="CompareShow($event)"></compareCompanys>
        </div> -->

    <!-- 提示选择多少条 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible2"
      :before-close="
        () => {
          riskScanDialogVisible2 = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_550"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_search_icon.png" />
        </div>
        <div class="dialog_title_img_text">{{ $t("RiskScan.Scanning") }}</div>
        <div class="risk_text">
          {{ $t("RiskScan.Youhaveselectedatotalof") }}
          <span class="num">{{ riskScanDialogLength }}</span>
          {{ $t("RiskScan.Tostartriskscanning") }}
        </div>
      </div>

      <div slot="footer" class="dialog_footer dialog_footer_display">
        <!-- <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_cancel_btn"
          type="cancel"
          >{{ $t("RiskScan.Cancel") }}</el-button
        > -->
        <el-button
          @click="confirmSanCheck"
          class="risk_primary_btn"
          type="primary"
          >{{ $t("RiskScan.Confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import { getUserCompanyActionPage, downloadOnlinePdf } from "@/api/userApi";
import FilterMenu from "../../components/FilterMenu.vue";
import Page from "@/components/page/index.vue";
import addCompany from "../adCppany/addCpmpanyCheck.vue";
import compareCompanys from "../../../company/list/compareCompanys.vue";

export default {
  mixins: [mixins1],
  components: {
    Page,
    addCompany,
    FilterMenu,
    compareCompanys,
  },
  props: {
    isOpenSlct: {
      type: Boolean,
    },
    Compare: {
      type: Boolean,
    },
    FilterObj: {
      type: Object,
    },
  },
  watch: {
    FilterObj: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$store.dispatch("app/setTools", {
            name: "riskScanning",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "customPortfolio",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "share",
            key: "isActive",
            value: false,
          });
          this.page.pageNo = 1;
          this.getgetUserActionLogPage();
        }

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.handleSelectionChange([]);
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++;

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Compare: {
      handler(newVal, oldVal) {
        // this.Compare = newVal;
        //         if (this.Compare) {
        //   this.setToolsfalse()
        // } else {
        //   this.handleSelectionChange([])
        //   this.refresh++
        // }
        // 在这里处理columns属性的变化
        // if (newVal == false) {
        //   this.handleSelectionChange([])
        //     this.compareList=[]
        //     this.$store.dispatch("app/setcollectList", []);
        //     this.$store.dispatch("app/setchangeList",  this.compareList);
        // }
        // this.refresh++
        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      riskScanDialogVisible2: false,
      riskScanDialogLength: 0,

      reLoginVis: false,
      addDialog: false,

      menuActive: 1,
      datePicker: [],
      CategoryVal: "",
      yourUsagelist: [],
      compareList: [],
      compareListParent: [],
      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      refresh: 0,
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: true,
    });
  },

  methods: {
    CompareShow(val) {},
    handleSelectionChange(val) {
      this.compareListParent = val;
      this.cheeckbooksUpdate(val);
    },

    cheeckbooksUpdate(val) {
      this.compareList = [...this.compareListParent];

      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: this.compareList.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      // 添加 选中公司
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.compareList.map((item) => {
        item.aaa_id = item.aaaid;
      });

      //添加 选中公司 风险扫描
      sessionStorage.setItem("riskScanList", JSON.stringify(this.compareList));
    },
    closeAdd(val) {
      this.addDialog = val;
    },
    MenuClick(item) {
      this.menuActive = item.value;
    },
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaid +
          "/background/snapshot?id3a=" +
          row.aaaid +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    Down(scope) {
      downloadOnlinePdf(scope.aaaid).then((res) => {
        const binaryData = [];
        binaryData.push(res);
        let pdfUrl = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/pdf" }),
        );
        window.open(pdfUrl, "_blank");
      });
    },
    getgetUserActionLogPage() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getUserCompanyActionPage({
        userId: userinfo.id,
        type: "",
        portfolioId: "",
        companyName: this.FilterObj.companyName,
        companyIsicEn: this.FilterObj.companyIsicEn,
        companyTypeEn: this.FilterObj.companyTypeEn,
        companyStatusEn: this.FilterObj.companyStatusEn,
        startTime: this.FilterObj.startTime,
        endTime: this.FilterObj.endTime,

        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.yourUsagelist = res.data.rows;
            this.page.total = res.data.total;
          } else {
            this.yourUsagelist = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    onPageChangeList({ page, size }) {
      this.handleSelectionChange([]);
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
      this.handleSelectionChange([]);
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage();
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;
      this.getgetUserActionLogPage();
    },
    //扫描确认
    confirmSanCheck() {
      this.riskScanDialogVisible2 = false;
      this.aaaidList = [];
      this.$store.state.app.changeList.map((item) => {
        this.aaaidList.push(item.aaa_id);
      });
      //跳转
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
        query: { aaaids: this.aaaidList.join("@@") },
      });
      window.open(routeData.href, "_blank");
    },

    //Rescan
    RescanCheckBook() {
      if (this.$store.state.app.changeList.length == 0) return;
      this.riskScanDialogVisible2 = true;
      this.riskScanDialogLength = this.$store.state.app.changeList.length;
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}
.form-email {
  display: flex;
  width: 100%;
}
.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}
.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}
.item_txtcolor2 {
  color: #55b419;
}
.item_txtcolor3 {
  color: #ffa000;
}
.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}
.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}
.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}
.das_top_item .color4 {
  background: #ff7600;
}
.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}
.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}
.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}
.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}
.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}
.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold";
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}
.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}
.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold" !important;
}
.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}
.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}
/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}
/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

.Data-Management-ul {
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
  width: max-content;
  margin: auto;
}
.Data-Management-ul li {
  padding: 10px 20px;
  cursor: pointer;
}
.menuActiveColor {
  background: #ffffff;
  border-radius: 4px;
}

.Addcompanies {
  margin-bottom: 14px;
  align-items: center;
  display: flex;
  gap: 20px;
}

.el-button {
  margin-left: 0px;
}

@media screen and (max-width: 1920px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
  .Addcompanies {
    margin-bottom: 10px;
    gap: 15px;
  }

  ::v-deep .el-table td.el-table__cell {
    height: 50px !important;
  }
  /* ::v-deep .el-table th.el-table__cell > .cell {
    padding-left: 15px;
    padding-right: 15px;
  } */
}

@media screen and (max-width: 1439px) {
  .btn_blue {
    font-size: 12px;
    width: max-content;
  }
  .Addcompanies {
    margin-bottom: 10px;
    gap: 13px;
  }
}
</style>
